import React, { useState } from "react";
import { createUser } from "../../services/api"; // Asegúrate de tener esta función en tu archivo api.js
import Breadcrumbs from "../../components/BreadCrumbs";

const UserCreate = () => {
  const [userData, setUserData] = useState({
    nombre: "",
    email: "",
    rol: "",
    equipo: "",
    password: "",
  });

  const handleChange = (e) => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createUser(userData);
      // Redirigir o mostrar mensaje de éxito
    } catch (error) {
      console.error("Error creating user:", error);
    }
  };

  // Definir las rutas para los breadcrumbs
  const breadcrumbPaths = [
    { name: "Dashboard", url: "/dashboard" },
    { name: "Users", url: "/dashboard/users" },
    {
      name: "Create user",
      url: "/dashboard/users/create",
    },
  ];

  return (
    <>
      <h2>Crear Caso de Prueba</h2>
      <Breadcrumbs paths={breadcrumbPaths} />
      <form onSubmit={handleSubmit}>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Nombre</label>
          <div class="col-sm-10">
            {" "}
            <input
              type="text"
              className="form-control"
              name="nombre"
              value={userData.nombre}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Email</label>
          <div class="col-sm-10">
            <input
              type="email"
              className="form-control"
              name="email"
              value={userData.email}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Equipo</label>
          <div class="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="equipo"
              value={userData.equipo}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Rol</label>
          <div class="col-sm-10">
            <select
              className="form-select"
              name="rol"
              value={userData.rol}
              onChange={handleChange}
              required
            >
              <option value="">Seleccionar...</option>
              <option value="admin">Administrador</option>
              <option value="developer">Developer</option>
              <option value="tester">Tester</option>
            </select>
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Password</label>
          <div class="col-sm-10">
            <input
              type="password"
              className="form-control"
              name="password"
              value={userData.password}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div style={{ textAlign: "end" }}>
          <button type="submit" className="btn btn-primary">
            Crear Usuario
          </button>
        </div>
      </form>
    </>
  );
};

export default UserCreate;
